import React from 'react'
 import TeamSection from './teamSection/TeamSection'
import Services from './services/Services'
 
const About = () => {
  return (
    <div className=''> 
    <Services/>
    <TeamSection/>

     </div>
  )
}

export default About